// @ts-nocheck
import React from "react"

import { Input } from "@atos6/ui"
import { useStore } from "../containers"

export function InputNameStateful() {
  const { name, documentType, setState } = useStore()
  const placeholder = documentType === "cpf" ? "Nome completo" : "Razão Social"

  return (
    <Input
      placeholder={placeholder}
      value={name}
      onChange={e => setState({ name: e.target.value })}
      size="large"
    />
  )
}
